import type { SubscriptionOptions } from '@reduxjs/toolkit/query/react'
import { useAppSelector } from '../../store/store'
import {
    useGetContractorsQuery,
    useGetMyContractorsQuery,
} from '../../store/api/contractors-api'
import { BusinessRole } from '../../types/api/user'
import { EndpointQueryParameters } from '../../types/strapi/strapi'

const UNRESTRICTED_ROLES = [BusinessRole.SuperAdmin, BusinessRole.Logist]

export const useScopedContractorsQuery = (
    params: EndpointQueryParameters,
    options?: SubscriptionOptions & { skip?: boolean }
) => {
    const user = useAppSelector(state => state.auth.user)
    const useAllClients = Boolean(
        user?.businessRoles?.some(role => UNRESTRICTED_ROLES.includes(role))
    )

    const allClientsResult = useGetContractorsQuery(params, {
        ...options,
        skip: !useAllClients || options?.skip,
    })
    const myClientsResult = useGetMyContractorsQuery(params, {
        ...options,
        skip: useAllClients || options?.skip,
    })

    return useAllClients ? allClientsResult : myClientsResult
}
